/*
  Product gallery dots.

  The gallery itself is CSS: a scroll-snap track below 900px, a grid above it.
  Scrolling, swiping and momentum are the browser's. This only keeps the dots
  in step with the track and lets a tap on a dot move it.

  Above 900px the dots are display:none and the track no longer scrolls, so
  every handler here is harmlessly inert — no matchMedia bookkeeping, no second
  source of truth about the breakpoint.
*/
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(gallery) {
    // The tag that loads this lives in the product section, not the layout, so
    // that pushing a gallery change never has to touch layout/theme.liquid.
    // A re-render in the theme editor can therefore run boot() twice over the
    // same node; bind once.
    if (gallery.dataset.galleryBound) return;
    gallery.dataset.galleryBound = 'true';

    var track = gallery.querySelector('[data-gallery-track]');
    var dotWrap = gallery.querySelector('[data-gallery-dots]');
    if (!track || !dotWrap) return;

    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(dotWrap.children);
    if (slides.length < 2 || dots.length !== slides.length) return;

    var active = 0;

    function mark(i) {
      if (i === active) return;
      active = i;
      dots.forEach(function (d, n) {
        if (n === i) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    // Nearest slide centre to the centre of the track, both measured in
    // viewport coordinates. offsetLeft is tempting and wrong: it is relative
    // to the nearest positioned ancestor, not to the track, so it carries the
    // page gutter as a constant error into every comparison.
    function current() {
      var box = track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestGap = Infinity;
      slides.forEach(function (s, n) {
        var r = s.getBoundingClientRect();
        var gap = Math.abs(r.left + r.width / 2 - mid);
        if (gap < bestGap) {
          bestGap = gap;
          best = n;
        }
      });
      return best;
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          mark(current());
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () {
        var box = track.getBoundingClientRect();
        var r = slides[n].getBoundingClientRect();
        var delta = r.left + r.width / 2 - (box.left + box.width / 2);
        track.scrollTo({
          left: track.scrollLeft + delta,
          behavior: reduced ? 'auto' : 'smooth'
        });
        // Deliberately no optimistic mark(n): a second tap during a smooth
        // scroll would then light a dot the handler immediately overwrites as
        // the first animation flies past. The scroll listener is the one
        // source of truth, and it fires for an instant scroll too.
      });
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
